import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PatientDetailsHeader from '../../../../components/Account/PatientDetailsHeader';
import MultiDatePicker from '../../../../components/documented/MultiDatePicker/MultiDatePicker';

interface Props {
  patientId?: string;
  selectedDateRange: [Date | null, Date | null];
  setSelectedDateRange?:
    | React.Dispatch<React.SetStateAction<[Date | null, Date | null]>>
    | undefined;
}

export const AverageWalkingSpeedDetailHeader: React.FC<Props> = ({
  patientId,
  selectedDateRange,
  setSelectedDateRange,
}) => {
  const { t } = useTranslation('dailyParameters');
  const navigate = useNavigate();
  const [dates] = useState<Date[]>();

  //ignore linting rules for the below for now - needed to make date picker work
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedMonth, setSelectedMonth] = React.useState<Date>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // useEffect(() => {
  //   //TODO - Try to set selected date to the date from the daily params page, if not just select today
  //   const range = getDateRanges(undefined, true);
  //   passiveParametersService.getDailyParameterDatesByRange(
  //     patientId!,
  //     range.startDate,
  //     range.endDate
  //   );
  //   //setSelectedDate(latestDate);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectedMonth]);

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        borderRadius: '40px 40px 0px 10px',
        margin: '0px 40px 0px 0px',
      }}
    >
      <Box sx={{ margin: '40px 40px 0px 40px' }}>
        <Box>
          <IconButton
            sx={{ width: '40px', height: '40px' }}
            color="primary"
            onClick={() => navigate(-1)}
          >
            <ArrowBackIcon sx={{ transform: 'scale(1.3)' }} />
          </IconButton>
        </Box>
        <PatientDetailsHeader nameOnly selectedPatientId={patientId} />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '20px',
            width: '100%',
          }}
        >
          <Typography variant="h4" component="h4">
            {t('averageWalkingSpeed.title')}
          </Typography>
          <MultiDatePicker
            isRangePicker
            dates={dates}
            isLoading={isLoading}
            setSelectedMonth={setSelectedMonth}
            selectedRange={selectedDateRange}
            setSelectedRange={setSelectedDateRange}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default AverageWalkingSpeedDetailHeader;
